export default __webpack_public_path__ + "static/media/bmw-group-logos.73c3e336.svg";